import React, { useEffect, useState } from 'react';
import { TrialContentContext } from '../context/ContentContext';
import { getSiteCoreContent } from '../services/sitecoreServices';
import { gtagEnvelope } from '../util/gtagEnvelope';

export const TrialContentProvider = ({ children }: { children: JSX.Element }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    getContent(controller.signal);

    return () => {
      controller.abort();
    };
  }, []);

  const getContent = (signal: AbortSignal) => {
    getSiteCoreContent(signal)
      .then((result) => {
        if (signal.aborted) return;
        if (result.status !== 200) {
          setData(false);
          gtagEnvelope('event', 'trial_page_error', {
            error_type: 'runtime_error',
            error_code: 500,
            error_message: `Trial content loading error status`,
          });
        }

        setData(result.data);
      })
      .catch((error) => {
        if (signal.aborted) return;
        gtagEnvelope('event', 'trial_page_error', {
          error_type: 'runtime_error',
          error_code: 500,
          error_message: `Trial content loading ${error.message}`,
        });
        setData(false);
      });
  };

  return <TrialContentContext.Provider value={data}>{children}</TrialContentContext.Provider>;
};
